<template>
  <v-container class="pa-0">
    <v-row
      v-for="(debtobj, index) in debtData"
      :key="index"
      class="text-center text-caption"
      :class="!isLastColumn ? 'whiteBackground' : 'blueBackground zlastColumn'"
    >
      <!-- 1 Top of the Accelerated Debt box -->
      <v-col
        v-if="debtobj.isBlueBoxTop === true && debtData[0].isAcceleratedDebt === true"
        cols="12"
      >
        <v-row>
          <v-col cols="12" class="blueBackgroundWhiteText">
            {{ $t('L_Accelerated_Debt') }}
          </v-col>
        </v-row>
        <v-row class="blueBorderTop blueBorderLeft blueBorderRight">
          <v-col cols="7" class="accelerationAmount text-left">
            <div>{{ $t('L_acceleration_amount') }}</div>
            <v-tooltip
              max-width="200"
              html="true"
              open-on-click
              :open-on-hover="false"
              location="bottom"
              close-delay="2000"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  color="blue-darken-2"
                  size="small"
                  v-bind="props"
                  class="moveiconup"
                  :icon="mdiHelpCircle"
                />
              </template>
              <div class="">
                <p v-html="$t('L_this_is_the_total')" />
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="5" class="grayDownArrowPillButton">
            <div class="spanMoveBubbleLeftInAcceleratedDebt">
              <v-img alt="arrow bubble" class="arrowBubble" src="../assets/6digit.png" />
            </div>
            <div class="monthlyAmountInBubbleAcceleratedDebt">
              {{ formattedMoney(debtobj.newPayment) }}
            </div>
          </v-col>
        </v-row>
      </v-col>

      <!-- 2 Bottom of the Accelerated Debt box -->
      <v-col
        v-else-if="debtobj.isBlueBoxBottom === true && debtData[0].isAcceleratedDebt === true"
        cols="12"
      >
        <v-row class="blueBorderLeft blueBorderRight blueBorderBottom">
          <!-- <v-col>
            <v-row> -->
          <v-col cols="7" text-left pl-4 class="accelerationAmount">
            {{ debtobj.debtName }}
          </v-col>
          <v-col cols="5" class="SecondDollarAmount">
            <span class="payThisAmountVal"
              >{{ formattedMoneyWSign(debtobj.newPayment - debtobj.acceleratedAmount) }}
            </span>
          </v-col>
          <!-- </v-row>
            <v-row> -->
          <v-col cols="7" text-left pl-4 class="payOffDate">
            {{ $t('L_pay_off_date') }} {{ getMonth(debtobj.projectedPayoffDate) }}
          </v-col>
          <v-col cols="5"> &nbsp; </v-col>
          <!-- </v-row>
            <v-row class="" mb-1> -->
          <v-col cols="7" class="payThisAmount">
            {{ $t('L_Pay_this_amount') }}
          </v-col>
          <v-col cols="5" class="payThisAmountVal">
            <div class="pillButtonPayThisAmount">
              {{ formattedMoney(debtobj.newPayment) }}
            </div>
          </v-col>
          <!-- </v-row> -->
          <!-- </v-col> -->
        </v-row>
      </v-col>

      <!-- 7 Hidden Top Most data for Accelerated Debt This will put space on top to account for blue bar for Accelerated Debt"  -->
      <v-col
        pl-3
        py-0
        cols="12"
        v-else-if="debtobj.isBlueBoxTop === false && debtobj.isAcceleratedDebt === true"
        class="eachCellSpacingPlusBlueBarHeight grayRight"
        zstyle="border: 2px solid red; color: red;"
      >
        <!-- <span> Hidden Data: {{ debtobj.debtName }} </span> <span class="text-align-right"> {{ debtobj.newPayment }}</span>  -->
      </v-col>

      <!-- 5 First Debt to Pay Off  with Blue Bar                                                                    -->
      <v-col
        v-else-if="debtobj.isBlueBoxTop === true && debtobj.isAcceleratedDebt === false"
        cols="12"
        class="px-0 py-0"
        style="margin-top: 4px"
      >
        <v-row class="ma-0 py-0">
          <v-col cols="12" class="blueBackgroundWhiteText py-0 text-center text-caption">
            {{ $t('L_first_debt_to_pay_off') }}
          </v-col>
        </v-row>
        <div class="blueBorderTop blueBorderLeft blueBorderRight blueBorderBottom">
          <v-row>
            <v-col cols="7" class="hideOverflowText text-left text-body-1 pl-5 pb-0">
              {{ debtobj.debtName }}
            </v-col>
            <v-col cols="5" class="firstDebtToPayOffBubbleSpacing text-right text-body-1 pr-5 pb-0">
              <span class="pillButtonPayThisAmountTwo">
                {{ formattedMoney(debtobj.newPayment) }}
              </span>
            </v-col>
            <v-col cols="12" class="payOffDatevtwo text-left pl-5 pt-0">
              {{ $t('L_pay_off_date') }} {{ getMonth(debtobj.projectedPayoffDate) }}
            </v-col>
          </v-row>
        </div>
      </v-col>

      <!-- 11 This is it since All Debt is paid -->
      <v-col
        v-else-if="debtobj.showOnlyMonthlyAmount === true && debtobj.islastDebt === true"
        cols="12"
        class="heightToEncompassYouDidItImgAndDontStopNowTxt dottedAggregateAmount mb-5 py-0"
      >
        <div class="raiseTheDotsOne">. . . . . . . . . . . . . . . . . .</div>
        <div class="dottedBubbleInMiddle">
          <v-img
            alt="amount per month"
            class="arrowBubbleBlueBorder"
            src="../assets/white-bubble-arrow.svg"
          />
        </div>
        <div class="dottedMonthlyAmountInBubbleMiddle text-center">
          {{ formattedMoney(debtobj.newPayment) }}
        </div>
        <!-- rocky balboa img -->
        <div cols="12" class="imageOfYouDidIt d-flex justify-center ml-5 my-2">
          <v-img
            alt="Debt paid off successfully"
            src="../assets/debt-success.svg"
            width="62px"
            height="70px"
          />
        </div>
        <div cols="12" class="youDidItText text-center">
          {{ $t('L_you_did_it') }}
        </div>
        <div cols="12" class="This_is_a_huge_step text-center">
          {{ $t('L_this_is_a_huge_step_toward') }}
        </div>
        <div class="blueBackground mx-2">
          <v-row class="moveBelowTotalInvestmentAmountWithBlueBox whiteBackground mt-2 pt-2 px-2">
            <template v-if="debtData.dontStopThereIndividualAmount > 0">
              <v-col cols="12" class="text-center px-0">
                <p class="dontStopNow pb-3">{{ $t('L_donot_stop_now') }}</p>
                <p class="startSaving">{{ $t('L_start_saving') }}</p>
                <p class="startSavingAmt font-weight-bold">
                  {{ formattedMoney(debtobj.newPayment) }}
                </p>
                <p class="eachMonthAndAccumulate">{{ $t('L_each_month_and_accumulate') }}</p>
                <p class="totalSavedAmount font-weight-bold">
                  {{ formattedMoney(debtData.dontStopThereIndividualAmount) }}
                </p>
                <p class="byRetirementAge">
                  {{ $t('L_by_retirement_age') }} {{ getRetirementAge }}
                </p>
              </v-col>
            </template>
            <v-col cols="12" class="pb-0 px-0">
              <p class="contactYourRepresentativeToday text-center">
                {{ $t('L_contact_your_representative_today') }}
              </p>
            </v-col>
            <v-col
              v-if="debtData.dontStopThereIndividualAmount > 0"
              cols="12"
              class="youCanUpdateTheRetirement pt-0 text-center px-0"
            >
              <p>
                {{ $t('L_you_can_update_the_retirement') }}
                <span @click="GoToRetirementGuidance" style="color: #063562; font-weight: 600">
                  {{ $t('L_retirement_guidance_calculator') }}
                </span>
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <!-- 9 This is the TopMost row, dashed with Money in Bubble for Unpaid/First Debt 2nd column (index ==1) only occurs in 1 case.  Need to account for blue bar height of first debt-->
      <v-col
        v-else-if="
          debtobj.isBlueBoxTop === false &&
          debtobj.isAcceleratedDebt === false &&
          debtobj.showOnlyMonthlyAmount === true
        "
        cols="12"
        class="eachCellSpacingPlusBlueBarHeightForFirstDebt grayBottomAndRight pl-3 py-0"
      >
        <span class="raiseTheDotsTwo"
          >. . . . . . . . . . . . . . . . . . . . . . . . . . . . .</span
        >
        <span :class="index == 0 ? 'dottedBubbleBigBox' : 'dottedBubble'">
          <v-img alt="arrow bubble" class="arrowBubble" src="../assets/6digit.png" />
        </span>
        <span class="dottedMonthlyAmountInBubbleOne"
          >{{ formattedMoneyWSign(debtobj.newPayment) }}
        </span>
      </v-col>

      <!-- 12 This is the TopMost row, dashed with Money in Bubble for Unpaid/First Debt 2nd column (index ==1) only occurs in 1 case.  Need to account for blue bar height of first debt-->
      <v-col
        v-else-if="debtobj.showOnlyMonthlyAmount === true"
        cols="12"
        :class="
          index == 0
            ? 'eachCellSpacingPlusFirstDebtBlueBarHeight paddingTopByHeightOfBlueBar'
            : 'paddingTopNone eachCellSpacing'
        "
        class="grayLeft grayBottomAndRight pl-3"
      >
        <div class="raiseTheDotsThree">
          . . . . . . . . . . . . . . . . . . . . . . . . . . . . .
        </div>
        <div
          v-if="index == 0"
          :class="debtobj.newPayment < 100000 ? 'dottedBubbleBigBoxTwo' : 'dottedBubbleBigBox'"
        >
          <v-img
            alt="arrow bubble"
            :class="debtobj.newPayment < 100000 ? 'arrowBubbleSmall' : 'arrowBubble'"
            src="../assets/6digit.png"
          />
        </div>
        <div v-else :class="debtobj.newPayment < 100000 ? 'dottedBubbleTwo' : 'dottedBubble'">
          <v-img
            alt="arrow bubble"
            :class="debtobj.newPayment < 100000 ? 'arrowBubbleSmall' : 'arrowBubble'"
            src="../assets/6digit.png"
          />
        </div>
        <div class="dottedMonthlyAmountInBubbleTwo text-right font-weight-bold">
          <span>{{ formattedMoneyWSign(debtobj.newPayment) }}</span>
        </div>
      </v-col>

      <!-- 10 Topmost Hidden cell for Unpaid. Need to add extra spacing to account for blue bar for Accelerated Debt-->
      <v-col
        pl-3
        py-0
        cols="12"
        v-else-if="
          debtobj.isBlueBoxTop === false &&
          debtobj.isAcceleratedDebt === false &&
          debtobj.hideData === true
        "
        class="grayRight"
        :class="index == 0 ? 'eachCellSpacingPlusFirstDebtBlueBarHeight' : 'eachCellSpacing'"
        zstyle="border: 2px dashed green; color: green;"
      >
        <!-- <span> Hidden Data: {{ debtobj.debtName }} </span> <span class="text-align-right"> {{ debtobj.newPayment }}</span>  -->
      </v-col>

      <!-- 8 Hidden Data Cell Logic for 2nd column onwards for both Paid and Unpaid                                                                     -->
      <v-col
        pl-3
        py-0
        cols="12"
        v-else-if="
          debtobj.hideData === true &&
          debtobj.showPayOffDate === false &&
          debtobj.showOnlyMonthlyAmount === false
        "
        class="grayLeft grayRight"
        :class="index == 0 ? 'eachCellSpacingPlusFirstDebtBlueBarHeight' : 'eachCellSpacing'"
        zstyle="border:1px dashed blue; color:blue;"
      >
        <!-- <span> Hidden Data: {{ debtobj.debtName }} </span> <span class="text-align-right"> {{ debtobj.newPayment }}</span>  -->
      </v-col>

      <!-- 4 This shows the payoff Date -->
      <v-col
        v-else-if="debtobj.showPayOffDate === true"
        cols="12"
        class="eachCellSpacing defaultDebtLeft grayLeft grayBottomAndRight text-left pl-3 py-0"
      >
        <v-row>
          <v-col cols="7" class="hideOverflowText pb-0">
            {{ debtobj.debtName }}
          </v-col>
          <v-col cols="5" class="numberFourPadding text-right pb-0">
            <span class="pillButtonPayThisAmountTwo">{{ formattedMoney(debtobj.newPayment) }}</span>
          </v-col>
          <v-col cols="12" class="payoffDateTwo py-0">
            {{ $t('L_pay_off_date') }} {{ getMonth(debtobj.projectedPayoffDate) }}
          </v-col>
        </v-row>
      </v-col>

      <!-- 6 This is the default view with debtName and newPayment -->
      <v-col
        v-else
        cols="12"
        class="hideOverflowText eachCellSpacing defaultDebtLeft grayLeft grayBottomAndRight text-left pl-3 py-0"
      >
        <v-row>
          <v-col cols="7" class="hideOverflowText pb-0">
            {{ debtobj.debtName }}
          </v-col>
          <v-col cols="5" class="text-right pr-4 pb-0">
            {{ formattedMoney(debtobj.newPayment - debtobj.acceleratedAmount) }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';
import { useDebtSolutionsStore } from '../store/debtsolutions.store';
import { format, parseISO } from 'date-fns';
import { mdiHelpCircle } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'DebtStackColumn',
  props: {
    debtData: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    rightMostCol: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  data: () => ({
    mdiHelpCircle,
  }),
  methods: {
    GoToRetirementGuidance() {
      // Go to Retirment Guidance;
    },
    getMonth(tObj: string) {
      const tDate = new Date(parseISO(tObj));
      const rDate = format(tDate, 'MM/yyyy');
      return rDate;
    },
    formattedMoney(strMoney: string | undefined) {
      return this.$n(strMoney, 'currency', 'en-US', { maximumFractionDigits: 0 });
    },
    formattedMoneyWSign(strMoney: string | undefined) {
      if (strMoney === undefined) {
        return '';
      } else if (strMoney.toString().includes('-')) {
        return this.$n(strMoney, 'currency', 'en-US', { maximumFractionDigits: 0 });
      }
      return `+${this.$n(strMoney, 'currency', 'en-US', { maximumFractionDigits: 0 })}`;
    },
  },
  computed: {
    ...mapState(useDebtSolutionsStore, {
      personInfo: 'personInfo',
      planWStacking: 'planWStacking',
    }),

    isLastColumn() {
      if (
        this.debtData[this.debtData?.length - 1].islastDebt === true &&
        this.debtData[this.debtData?.length - 1]?.showOnlyMonthlyAmount === true
      ) {
        return true;
      }
      return false;
    },
    getRetirementAge() {
      const retAge =
        this.planWStacking?.planTotals?.dontStopThereIndividualAge > 0
          ? this.planWStacking?.planTotals?.dontStopThereIndividualAge
          : this.personInfo.retirementAge;
      return `${retAge}*`;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.whiteBackground {
  background-color: #ffffff;
}
.text-align-right {
  text-align: right;
}
.hideOverflowText {
  white-space: nowrap;
  overflow: hidden;
}
.eachCellSpacing {
  height: 50px;
  line-height: 50px;
}
.blueBackgroundWhiteText {
  background-color: #063562;
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
}
.moveiconup {
  position: absolute;
  margin-top: -20px;
  padding-left: 32px;
}
.accelerationAmount {
  color: #063562;
  font-size: 14px;
}
.blueBorderBottom {
  border-bottom: 1px solid #063562;
}
.grayLeft {
  border-left: 1px solid rgba(212, 212, 212, 0.5);
}
.grayRight {
  border-right: 1px solid rgba(212, 212, 212, 0.5);
}
.grayBottomAndRight {
  border-right: 1px solid rgba(212, 212, 212, 0.5);
  border-bottom: 1px solid rgba(212, 212, 212, 0.5);
}
.blueBorderTop {
  border-top: 1px solid #063562;
}
.blueBorderLeft {
  border-left: 1px solid #063562;
}
.blueBorderRight {
  border-right: 1px solid #063562;
}
.monthlyAmountInBubble {
  position: absolute;
  margin-top: -50px;
  font-size: 16px;
  color: #063562;
  margin-left: -35px;
  font-weight: 600;
}
.monthlyAmountInBubbleAcceleratedDebt {
  position: absolute;
  margin-top: 5px;
  font-size: 16px;
  color: #063562;
  margin-left: -25px;
  font-weight: 600;
}
.secondText {
  font-size: 16px;
}
.payOffDate {
  font-size: 11px;
  color: #02579e;
  position: relative;
  margin-top: -5px;
}
.payThisAmount {
  font-size: 12px;
  color: #063562;
}
.payThisAmountVal {
  font-size: 16px;
  color: #063562;
  font-weight: 600;
}
.pillButtonPayThisAmount {
  border: 1px solid #063562;
  border-radius: 16px;
  position: relative;
  padding: 5px;
}
.defaultDebtLeft {
  font-size: 16px;
  color: #333333;
}
.dottedAggregateAmount {
  font-size: 16px;
}
.raiseTheDotsTwo {
  position: absolute;
  margin-top: 2px;
  margin-left: -130px;
}
.raiseTheDotsThree {
  position: absolute;
  margin-top: -8px;
  margin-left: -24px;
}
.raiseTheDotsFour {
  position: absolute;
  margin-top: 2px;
  margin-left: -130px;
}
.dottedBubbleBigBox {
  position: absolute;
  margin-left: 135px;
  margin-top: -10px;
}
.dottedBubbleBigBoxTwo {
  position: absolute;
  margin-left: 160px;
  margin-top: -10px;
}
.dottedBubble {
  position: absolute;
  margin-left: 138px;
  margin-top: 5px;
}
.dottedBubbleTwo {
  position: absolute;
  margin-left: 160px;
  margin-top: 5px;
}
.raiseTheDotsOne {
  position: absolute;
  margin-top: 0px;
  margin-left: -10px;
}
.dottedBubbleInMiddle {
  position: absolute;
  margin-left: 56px;
  margin-top: -28px;
}
.dottedMonthlyAmountInBubbleMiddle {
  position: relative;
  margin-top: 12px;
  margin-left: 0px;
  font-weight: 600;
  font-size: 16px;
  color: #063562;
  padding-bottom: 55px;
}
.arrowBubbleBlueBorder {
  width: 159px;
  height: 122px;
}
.dottedMonthlyAmountInBubbleOne,
.dottedMonthlyAmountInBubbleTwo,
.dottedMonthlyAmountInBubbleThree {
  font-weight: 600;
  font-size: 16px;
  color: #063562;
}
.dottedMonthlyAmountInBubbleOne {
  position: absolute;
  margin-top: -5px;
  margin-left: 0px;
}
.dottedMonthlyAmountInBubbleTwo {
  position: relative;
  margin-top: -4px;
  padding-right: 20px;
}
.dottedMonthlyAmountInBubbleThree {
  position: absolute;
  margin-top: -5px;
  margin-left: 0px;
}
.payoffDateTwo {
  font-size: 11px;
  color: #02579e;
  position: relative;
  margin-top: -35px;
}
.eachCellSpacingPlusBlueBarHeight {
  height: 95px;
}
.eachCellSpacingPlusFirstDebtBlueBarHeight {
  height: 65px;
}
.eachCellSpacingPlusBlueBarHeightForFirstDebt {
  height: 85px;
  padding-top: 23px;
}
.imageOfYouDidIt {
  padding-bottom: 0px;
}
.youDidItText {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}
.This_is_a_huge_step {
  font-size: 18px;
  color: #333333;
  line-height: 1.43;
}
.overlayOnTopOfData {
  position: relative;
  padding-top: -44px;
}
.heightToEncompassYouDidItImgAndDontStopNowTxt {
  height: 570px;
}
.moveBelowTotalInvestmentAmountWithBlueBox {
  padding-top: 75px;
  border: 1px solid #f5faff;
  border-radius: 16px;
}
.eachMonthAndAccumulate {
  line-height: 1.25;
}
.byRetirementAge {
  line-height: 1;
}
.dontStopNow,
.startSaving,
.eachMonthAndAccumulate,
.byRetirementAge,
.contactYourRepresentativeToday {
  font-size: 16px;
  color: #333333;
}
.startSavingAmt,
.totalSavedAmount {
  font-size: 18px;
  color: #063562;
  font-weight: 600;
}
.youCanUpdateTheRetirement {
  font-size: 10px;
  color: #333333;
}
.linkText {
  color: #063562;
  font-weight: 600;
}
.background-lightBlue {
  background-color: #f5faff;
}
.payOffDatevtwo {
  font-size: 11px;
  color: #02579e;
}
.pillButtonPayThisAmountTwo {
  border: 1px solid #063562;
  border-radius: 16px;
  padding: 0px 10px 0px 10px;
}
.heightForBlueBarAndRegularCell {
  margin-top: 18px;
  height: 45px;
  line-height: 45px;
}
.bluePillButton {
  border: 1px solid #063562;
  border-radius: 16px;
  position: relative;
  padding: 5px;
}
.paddingTopByHeightOfBlueBar {
  padding-top: 35px;
}
.paddingTopNone {
  padding-top: 5px;
}
.arrowBubble {
  width: 116px;
  height: 48px;
}
.arrowBubbleSmall {
  width: 94px;
  height: 48px;
}
.zarrowBubbleForAcceleratedDebt {
  width: 100px;
  height: 48px;
}
.spanMoveBubbleLeftInAcceleratedDebt {
  position: absolute;
  margin-left: -47px;
}
.blueBackground {
  background-color: #f5faff;
}
.lastColumn {
  position: absolute;
  margin-top: -100px;
  width: 230px;
}
.firstDebtToPayOffBubbleSpacing {
  padding-right: 14px;
}
.numberFourPadding {
  padding-right: 18px;
}
</style>
